import _arity from './_arity.js';
import _curry2 from './_curry2.js';

export default function _createPartialApplicator(concat) {
  return _curry2(function (fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function () {
      return fn.apply(this, concat(args, arguments));
    });
  });
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_createPartialApplicator.js
// module id = 439
// module chunks = 2 3 4 5 6 7 8 10